export default __webpack_public_path__ + "static/media/typetwo-booth-card-bg.4fca86de.png";